import { z } from "zod";

export const addSpecimenSchema = z.object({});
export type AddSpecimenValues = z.infer<typeof addSpecimenSchema>;
